<template>
  <div class="main">
    <div class="container">
      <ul class="breadcrumb">
        <li>
          您所在的位置：
        </li>
        <li class="alpha hover">
          <a>首页</a>
        </li>
        <li class="alpha">
          <a>暂停通讯工具号码网上公示</a>
        </li>
      </ul>
      <div class="search">
        <div class="form-group form-group-lg" >
<!--          <el-input v-model="form.tel" placeholder="请输入手机号或者电话号码" class="input-box" ></el-input>-->
          <input  class="form-control" v-model="form.tel" placeholder="请输入手机号或者电话号码"></input>
          <div @click="changeFn" class="btn btn-primary btn-lg">搜索</div>
        </div>
      </div>
      <div class="box box-shadow box-highlight">
        <div class="row district">
          <el-row :gutter="20">
            <el-col :span="6" v-for="item in depList" :key="item.guid"><div class="grid-content " @click="clickFn(item.guid,item.name)" >{{item.name}}</div></el-col>
          </el-row>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {getDepList} from '@/http'
export default{
  data(){
    return{
      form:{},
      depList:[]
    }
  },
  methods:{
    changeFn(){
      this.$router.push({path:'/list',query:{tel:this.form.tel}})
    },
    clickFn(id,name){
      this.$router.push({path:'/list',query:{guid:id,tel:this.form.tel,name:name}})
    }
  },
  created() {
    getDepList().then(res => {
      this.depList = res
    })
  }
}
</script>
<style lang="less">
#app{
  background-color: #FFFFFF;
}
.pageFooter{
  background-color: #FFFFFF;
}
.main{
  .container{
    width: 1000px;
    padding-right: 15px;
    padding-left: 15px;
    margin-right: auto;
    margin-left: auto;
    .breadcrumb{
      background-color: transparent;
      font-size: 14px;
      margin-bottom: 10px;
      padding: 0 8px 10px 0;
      list-style-type:none;
      li + li:before {
        content: ">";
        color: #333;
        padding: 0 5px;
      }
      :nth-child(2):before{
        display: none;
      }
      .hover{
        cursor: pointer;
      }
      li{
        display: inline-block;
        }
      .alpha{
        a{
         color: #333;
        }
      }
      .active{
        color: #777;
      }
    }

    .search{
      background-color: #E5E5E5;
      border: 1px solid #D1D1D1;
      padding: 20px 30px 15px;
      margin: 10px 0 30px;
      .form-group-lg:focus-visible{
        border-color: #66afe9;
      }
      .form-group{
        position: relative;
        margin-bottom: 15px;
        .el-input__inner{
          height: 54px;
          line-height: 54px;
          padding-left: 50px;
          position: relative;

        }
        .el-input__inner:before{
          content: '';
          width: 32px;
          height: 32px;
          position: absolute;
          left: 0;
          top: 0;
          background: #FFF url(../../assets/img/icon-search.png) no-repeat 15px center;
        }
        .form-control {
          border-radius: 0;
          width: 100%;
          height: 56px;
          background: #FFF url(../../assets/img/icon-search.png) no-repeat 15px center;
          padding: 10px 16px;
          padding-left: 60px;
          font-size: 18px;
          line-height: 1.3333333;
          border: 1px solid #ccc
        }
        .form-control:focus,.form-control:focus-visible{
          border-color: #66afe9;
          outline: 0;
        }
        .btn-primary {
          color: #fff;
          background-color: #337ab7;
          border-color: #2e6da4;
        }
        .btn, .btn-lg {
          padding: 10px 16px;
          font-size: 18px;
          line-height: 1.3333333;
          border-radius: 6px;
        }
         .btn {
          position: absolute;
          right: 1px;
          top: 1px;
          width: 114px;
          border-radius: 0;
          //padding: 13px 16px;
           border-color: #2e6da4;
           height: 54px;
           text-align: center;
           line-height: 36px;
           cursor: pointer;
        }
      }
    }
    .box {
      border-style: solid;
      border-width: 1px;
      border-color: transparent;
      margin-bottom: 30px;
    }
    .box-highlight {
      border-top-width: 3px;
      border-color: #E98018 #D1D1D1 #D1D1D1 #D1D1D1;
    }
    .box-shadow {
      position: relative;
      min-height: 100px;
    }
    .district {
      padding: 30px 50px 15px
    }



  }
}
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border: 1px solid #D1D1D1;
  min-height: 40px;
  text-align: center;
  line-height: 40px;
  margin-bottom: 16px;
}
.grid-content:hover{
  background-color: #f2f2f2;
  cursor: pointer
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
</style>
